WiseMetering.Collection.Users = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.User,
    url: '/users',

    assignable: function() {
        // administrators reach every site already; everyone else in the listing is a member
        return new WiseMetering.Collection(this.where({ administrator: false }));
    }
});
